import { GET_PRODUCT_CUSTOM_ATTRIBUTE_RULE } from '@/typed-graphql/query';
import { useLazyQuery } from '@apollo/client';
import { useEffect, useMemo } from 'react';

export const useProductCustomAttributeRule = ({ urlKey }) => {
  const [getProductCustomAttributeRule, { data: productCustomAttributeData }] = useLazyQuery(
    GET_PRODUCT_CUSTOM_ATTRIBUTE_RULE,
    {
      fetchPolicy: 'no-cache',
      variables: {
        urlKey: urlKey,
      },
      onCompleted(data) {},
    },
  );

  useEffect(() => {
    getProductCustomAttributeRule();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customAttributeTreeData = useMemo(() => {
    if (!productCustomAttributeData) {
      return null;
    }

    try {
      return JSON.parse(productCustomAttributeData.products.items[0].custom_attribute_rule);
    } catch (error) {
      return null;
    }
  }, [productCustomAttributeData]);

  return {
    customAttributeTreeData,
  };
};
